import { useMutation, useQueryClient } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import { invalidateTaskRelatedQueries } from "@/utils/cacheInvalidation";

type TaskRemoveResponseType = ResponseType<null>;

function useRemoveTaskMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation<
    AxiosResponseAndError<TaskRemoveResponseType>["response"],
    AxiosResponseAndError<TaskRemoveResponseType>["error"],
    string
  >({
    mutationFn: (data) =>
      ApiRequest.delete<TaskRemoveResponseType>(`${requestURLs.task}${data}`),
    onSuccess: (_, deletedTaskId) => {
      void invalidateTaskRelatedQueries(queryClient, {
        taskId: deletedTaskId,
      });
    },
  });

  return mutation;
}

export default useRemoveTaskMutation;
